var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Anchor',{on:{"click":function($event){return _vm.$emit('openLink')}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('Icon',{attrs:{"small":"","color":_vm.titleColor}},[_vm._v("\n    mdi-open-in-new\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }